/**
 * logan依赖的环境代码及摇一摇组件打包到一起
 */
import Env from './env';
var Shake = require('shake.js');
export default {
    Env: Env,
    Shake: Shake
};
